import { errorFlags, useFlagsService } from '@atlassian/jira-flags';
import { useIntl } from '@atlassian/jira-intl';
import {
	type MenuNode,
	MenuNodeType,
} from '@atlassian/jira-software-context-menu/src/common/types.tsx';
import { showCopySuccessfulFlag } from '@atlassian/jira-software-copy-to-clipboard/src/ui';
import { COPY_ISSUE_LINK_MENU_ID } from '../../constants';
import messages from '../../messages';
import type { Props } from './types';

export const useCopyIssueLinkContent = ({ issueKey, selectedCardIds }: Props): MenuNode[] => {
	const { formatMessage } = useIntl();
	const { showFlag } = useFlagsService();

	// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
	const issueUrl = `${window.location.protocol}//${window.location.hostname}/browse/${issueKey}`;

	if (selectedCardIds.length > 1) return [];

	const onCopyIssueLink = () =>
		// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
		navigator.clipboard
			.writeText(issueUrl)
			.then(() => {
				showFlag(showCopySuccessfulFlag());
			})
			.catch(() => {
				showFlag(errorFlags.genericError());
			});

	return [
		{
			type: MenuNodeType.Item,
			label: formatMessage(messages.copyIssueLink),
			id: COPY_ISSUE_LINK_MENU_ID,
			onClick: onCopyIssueLink,
		},
	];
};

export const useCopyIssueLink = ({ issueKey, selectedCardIds }: Props) =>
	useCopyIssueLinkContent({ issueKey, selectedCardIds });
